const modulePages = [
	{
		id: 'm2-page-1',
		isFacilitatorOnly: false,
		title: 'KEND FORSKEL PÅ ALARMHJERNEN OG TÆNKEHJERNEN',
		facilitatorText: `Gå til www.basalsammen.dk. Skriv kode i elevlogin.
			<br /><br /><span><%GAMECODE%></span>`,
		groupText: `Start den digitale øvelse og match udsagn til alarmhjernen eller tænkehjernen.`,
		icons: [],
		slides: [
			{
				
				type: 'video',
				videoType: 'youtube',
				text: 'SE VIDEO',
				videoId: 'pi0Ggp18FhE',
				roles: ['facilitator']
			},
			{
				id: 'm2-slide-1',
				type: 'image', 
				text: 'SLIDE 1',
				roles: ['facilitator']
			},
			{
				id: 'm2-slide-2',
				type: 'image', 
				text: 'SLIDE 2',
				roles: ['facilitator']
			},
		],
		minigames: [
			require('data/minigames/m2-the-two-brains').minigameData
		],
	},
	{
		id: 'm2-page-2',
		isFacilitatorOnly: false,
		title: 'HVAD KAN AKTIVERE ALARMHJERNEN?',
		facilitatorText: `Gå til www.basalsammen.dk. Skriv kode i elevlogin.
			<br /><br /><span><%GAMECODE%></span>`,
		groupText: `Hvad kan aktivere alarmhjernen? Åbn opslagstavlen og skriv eksempler.`,
		icons: [],
		slides: [
			{
				id: 'm2-stroop-1',
				type: 'image',
				text: 'STROOP 1',
				roles: ['facilitator']
			},
			{
				id: 'm2-stroop-2',
				type: 'image', 
				text: 'STROOP 2',
				roles: ['facilitator']
			},
			{
				id: 'm2-model',
				type: 'image',
				text: 'MODEL',
				roles: ['facilitator']
			},
		],
		minigames: [
			require('data/minigames/m2-alarm-brain-examples').minigameData
		]
	},
	{
		id: 'm2-page-3',
		isFacilitatorOnly: true,
		title: 'HVORDAN FÅR MAN RO PÅ ALARMHJERNEN?',
		facilitatorText: null,
		groupText: null,
		icons: [],
		slides: [
			{
				id: 'iderunde',
				type: 'image',
				text: 'Idérunde'
			},
			{
				type: 'video', 
				videoType: 'ignite',
				videoLink: 'https://kfs.euvideocdn.com/player/index.html?id=6a426033ac55558c817943d7',
				text: 'SE VIDEO'
			},
			{
				type: 'iframe',
				text: 'SE VISUALISERING',
				title: 'Taktisk vejrtrækning',
				link: 'https://db.sammenomtrivsel.com/vejrtraekning/'
			},
			{
				id: 'm2-basalboxen',
				type: 'image',
				text: 'BASALBOXEN'
			},
			{
				id: 'm2-ovelse',
				type: 'image',
				text: 'ØVELSE'
			}
		]	
	}
];


export {
	modulePages
};